import React from 'react';
import { Helmet } from "react-helmet";

// Interface for page props
interface PageProps {
    PageTitle: string;
    PageDescription: string;
    PageKeywords?: string;
    OpenGraphURL?: string;
    CanonicalURL?: string;
}

// Interface for component props
interface PageHelmetProps {
    props?: PageProps;
}

export default function PageHelmet({props}: PageHelmetProps) {

    if (!props) return null
    
	return (
        <PageDetailedHelmet 
            title = {props.PageTitle}
            description = {props.PageDescription}
            keywords = {props.PageKeywords}
            openGraphURL = {props.OpenGraphURL}
            canonicalURL = {props.CanonicalURL}
        />
	)
} 

// Interface for PageDetailedHelmet props
interface PageDetailedHelmetProps {
    title: string;
    description: string;
    keywords?: string;
    openGraphURL?: string;
    canonicalURL?: string;
}

function PageDetailedHelmet({
    title, 
    description, 
    keywords, 
    openGraphURL, 
    canonicalURL}: PageDetailedHelmetProps) {

	return (
		<Helmet>
			<title>{title}</title>
 			<meta name="description" content={description} />
    		{
                keywords && keywords.length > 0 &&
	    		    <meta name="keywords" content={keywords} />
            }
			{
				openGraphURL && openGraphURL.length > 0 && 
                    <meta property="fb:app_id" content="688252041989357" />
			}
			{
				openGraphURL && openGraphURL.length > 0 && 
                    <meta property="og:url" content={openGraphURL} />
			}
            <meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
            {
                canonicalURL && canonicalURL.length > 0 &&
                    <link rel="canonical" href={canonicalURL} />
            }
        </Helmet>
    )
} 

